import React, { useState, useEffect, useCallback } from 'react'
import SoldGalasModal from '../../../components/Modal/SoldGalasModal';
import Table from '../../../components/Table';
import DocUploadModal from '../../../components/Modal/DocUploadModal';
import { environment } from '../../../env';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import { Form, Label } from 'reactstrap'
import 'react-toastify/dist/ReactToastify.css';
import _, { filter } from "lodash";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction, warningModalToggle, getSoldGalaAction, getBuildingAction } from '../../../redux/actions/Index';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ResellGalasModal from '../../../components/Modal/ResellGalasModal';
import { Eye, Users, Trash, User } from '@phosphor-icons/react';
import moment from 'moment';
import SoldGalaGroupModal from '../../../components/Modal/SoldGalaGroupModal';
import EditSoldGala from '../../../components/Modal/PDF/EditSoldGala';
import PathName from '../../../components/PathName/PathName';
import Excel from '../../../Helper/Excel';
import WarningPopup from '../../../components/Popups/WarningPopup';
import { useRef } from 'react';
import LoadBox from "../../../components/Loading/LoadBox";
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';

const SoldGalas = () => {
  const [tog, setTog] = useState(false);
  const [emptyerr, setEmptyerr] = useState(false);
  const [groupID, setGroupID] = useState();
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [buildingfilterdata, setbuildingfilterdata] = useState();
  const [galafilterdata, setgalafilterdata] = useState();
  const [GalaFilters, setGalaFilters] = useState([]);
  const [GalaFil, setGalaFil] = useState([]);
  const [area, setArea] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SubGalaFil, setSubGalaFil] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [records, setRecords] = useState(10);
  const [nextIsValid, setNextIsValid] = useState(false);
  const [prevIsValid, setPrevIsValid] = useState(false);
  const [validProjectName, setValidProjectName] = useState(false);
  const [stopExtraClearCall, setStopExtraClearCall] = useState(false)
  const apiTimeOut = useRef(null);

  if (SubGalaFil) {
    var subGalaFilter = Array.from(new Set(SubGalaFil.map((item) => item.sub_gala_name).sort((a, b) => a - b)))
  }

  const dispatch = useDispatch();
  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const galaList = useSelector((state) => state?.ModalReducer?.galaList);
  const soldGalas = useSelector((state) => state?.ModalReducer?.soldGalaList);
  const user = useSelector((state) => state?.Reducers?.userdata);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  let projectName = projectList?.filter((data, i) => data.id == userProject)

  var soldGalaList = soldGalas?.filter(item => item.resell_area !== item.sold_gala_area && item.project.id == userProject)

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const ordinal = (i) => {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  const deleteProjectData = (id) => {
    dispatch(warningModalToggle(id));
  };

  const deleteData = (id) => {
    axios.delete(`${environment.baseUrl}editsold-gala/${id}`).then(res => {
      if (res.data.code === 200) {
        getSoldGalaData();
        getBuildingData();
        SoldGalaFilterApiCall();
        dispatch(warningModalToggle())
        toast.success('Investor Removed Successfully', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
    })
      .catch(res => {
        console.log("error");

      })

  };

  const getSoldGalaData = async () => {
    try {
      let soldGalaApi = 'sold-gala'
      localStorage.setItem(soldGalaApi,true);
      let retureData = [];
      await axios.get(`${environment.baseUrl}sold-gala/`).then(res => {
        let data = res.data.filter((data, i) => data?.project.id == userProject)
        dispatch(getSoldGalaAction(data));
        localStorage.removeItem(soldGalaApi);
        retureData = data;
      }).catch(res => {
        console.log("error");
        localStorage.removeItem(soldGalaApi);
      })
      return retureData;
    }
    catch (err) {
      console.log(err);
    }
  };

  const getBuildingData = () => {
    try {
      axios.get(`${environment.baseUrl}building/`).then(res => {
        let data = res.data.filter((data, i) => data?.project.id == userProject)
        dispatch(getBuildingAction(data));
        setFilterBuilding(data)
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if ((filterBuilding == undefined || filterBuilding?.length == 0) && userProject != undefined) {
      getBuildingData();
    }
  }, [userProject])


  const columns = [
    {
      name: 'Status',
      selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <label className={`${row.ownership === 1 && 'icon-bg-green icon-color-green '} ${row.ownership === 2 && 'icon-bg-yellow icon-color-yellow'} ${row.ownership == 3 && 'status-bg-blue status-color-blue'} ${row.ownership >= 4 && 'bg-info text-white'}   rounded-pill status-box rounded fs-4`}>{`${ordinal(row.ownership)} Owner`}</label>
      </div>,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Owner Type',
      selector: row => <div className="d-flex justify-content-between align-items-center gap-3 " >
        <span>{row?.ownertype == "Self" ? <User size="26" className='text-base-red' /> : row?.ownertype == "Joined" && <Users size="26" className='status-color-blue' />}</span>
        <label className='fs-3'>{row?.ownertype}</label>
      </div >,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Party Name',
      selector: row => row.Investors?.name,
      sortable: true,
      wrap: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sell Date',
      selector: row => moment(row.created_at).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building No',
      selector: row => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },

  {
    name: 'Gala No',
    selector: row => Number(row.gala?.gala_no),
    sortable: true,
    style: {
      fontSize: "2.3rem",
    }
  }, {
    name: 'Sub Gala',
    selector: row => row.sub_gala_name,
    sortable: true,
    style: {
      fontSize: "2.3rem",
    }
  },
  {
    name: 'Area',
    selector: row => (row.sold_gala_area - row.resell_area) + " " + "Sq.ft",
    sortable: true,
    style: {
      fontSize: "2.3rem",
    }
  },
  {
    name: 'Upload',
    cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
      <DocUploadModal type={"soldgala"} soldGalaId={row?.id} />
    </div>,
  },
  {
    name: 'Action',
    cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
      <Link to={`/SoldGalas/${row.id}:details`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="24" className='icon-color-green' /></Link>
      {user?.role != 'user' && <EditSoldGala data={row} galaSoldHandeler={OnGalaSoldHandeler}/>}
      {user?.role == "superadmin" && <button onClick={() => deleteProjectData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="24" className='icon-color-red' /></button>}
    </div>,
  },
  ];

  var selectedBuildingId = watch("building");
  var selectedGala = watch("gala_no")
  var selectedsGala = watch("sub_gala_no")
  var selname = watch("search")
  var ownership = watch("proposal_status")

  selname = (selname == undefined ? "" : selname);

  useMemo(() => {
    let buildings = buildingList?.filter((data, i) => data.project.id == userProject)
    setFilterBuilding(buildings)
  }, [userProject])

  const SoldGalaFilterApiCall = async(clear=undefined) => {
    setLoading(true);
    let SearchUrl =  "";
    if(clear != undefined && clear == true){
      SearchUrl = `${environment.baseUrl}get-sold-galas-filter/?gala=${""}&building=${""}&project=${projectName[0]?.name}&investor=${""}&subgala=${""}&owner=${""}&p=1&records=${records}`;
    }else{
      SearchUrl = `${environment.baseUrl}get-sold-galas-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}&subgala=${selectedsGala == undefined ? "" : selectedsGala}&owner=${ownership == undefined ? "" : ownership}&p=1&records=${records}`;
    }
    if(pageNo != 1){
      setPageNo(1);
    }
    const result = await axios(SearchUrl).then((res) => {
      if(res?.data?.next != null && nextIsValid != true){
        setNextIsValid(true)
      }else if(res?.data?.next == null && nextIsValid != false){
        setNextIsValid(false)
      }
      if(res?.data?.previous != null && prevIsValid != true){
        setPrevIsValid(true)
      }else if(res?.data?.previous == null && prevIsValid != false){
        setPrevIsValid(false)
      }
      if (res?.data?.results.length > 0) {
        const dat = res?.data?.results
        if (dat.length != 0) {
          setEmptyerr(false)
          setGalaFilters(dat);
          let area = 0;
          dat.map((data, i) => { area = Number(Number(data.sold_gala_area) - Number(data.resell_area)) + Number(area) })
          setArea(area)
        } else {
          setEmptyerr(true);
          setArea(0)
          dispatch(loaderAction(false))
        }
      } else {
        setEmptyerr(true);
        setArea(0)
      }
      setLoading(false);
    })
  }

  useMemo(()=>{
    if(projectName != undefined && validProjectName == false){
      setValidProjectName(true);
    }
  },[projectName])

  useEffect(() => {
    if (userProject) {
      if (selectedGala || selectedBuildingId || selname || ownership) {
        SoldGalaFilterApiCall();
      }
    }
  }, [selectedGala, selectedBuildingId, userProject, ownership, selectedsGala])

  useMemo(() => {
    if (userProject) {
      if(stopExtraClearCall){
        setStopExtraClearCall(false)
        return
      }
      if (apiTimeOut.current) {
        clearTimeout(apiTimeOut.current)
      }
      if (selname != undefined && projectName != undefined) {
        setLoading(true);
        apiTimeOut.current = setTimeout(() => {
          const SearchUrl = `${environment.baseUrl}get-sold-galas-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}&subgala=${selectedsGala == undefined ? "" : selectedsGala}&owner=${ownership == undefined ? "" : ownership}&p=1&records=${records}`;
          if(pageNo != 1){
            setPageNo(1);
          }
          const result = axios(SearchUrl).then((res) => {
            if(res?.data?.next != null && nextIsValid != true){
              setNextIsValid(true)
            }else if(res?.data?.next == null && nextIsValid != false){
              setNextIsValid(false)
            }
            if(res?.data?.previous != null && prevIsValid != true){
              setPrevIsValid(true)
            }else if(res?.data?.previous == null && prevIsValid != false){
              setPrevIsValid(false)
            }
            if (res?.data?.results.length > 0) {
              const dat = res.data?.results;
              if (dat.length != 0) {
                setEmptyerr(false)
                setGalaFilters(dat);
                let area = 0;
                dat.map((data, i) => { area = Number(Number(data.sold_gala_area) - Number(data.resell_area)) + Number(area) })
                setArea(area)
              } else {
                setEmptyerr(true);
                setArea(0)
                dispatch(loaderAction(false))
              }
            } else {
              setEmptyerr(true);
              setArea(0)
            }
            setLoading(false)
          })
          apiTimeOut.current = null;
        }, 2000)
      } else {
        setGalaFilters([])
      }
    }
  }, [selname, validProjectName])

  useMemo(() => {
    {
      var projectBuilding = buildingList?.filter((filterBuilding) => filterBuilding.project.id == userProject);
      setFilterBuilding(projectBuilding);
      galaselected = soldGalaList?.filter((galalist) => galalist.project.name == projectName[0]?.name);
    }
    if (selectedBuildingId) {
      var galaselected = soldGalaList?.filter((galalist) => galalist.building.building_no == selectedBuildingId);
      var galaselectedd = galaList?.filter((galalist) => galalist.building.building_no == selectedBuildingId);
      var build = buildingList.filter((data, i) => data.building_no == selectedBuildingId)
      setbuildingfilterdata(build[0])
      setGalaFil(galaselectedd);
      setSubGalaFil([])
    } else {
      if (projectName) {
        return
      }
      else {
      }
    }
    if (selectedGala) {
      var gala = galaList.filter((data, i) => data.gala_no == selectedGala)
      var galall = galaList.filter((data, i) => data.gala_no == selectedGala && data.building.building_no == selectedBuildingId)
      var galaselected = soldGalaList?.filter((galalist) => galalist?.gala?.gala_no == selectedGala & galalist.building.building_no == selectedBuildingId);
      setSubGalaFil(galaselected)
      setgalafilterdata(galall[0])
    }
    if (selectedsGala) {
      var galaselected = soldGalaList?.filter((galalist) => galalist?.sub_gala_name == selectedsGala && galalist?.gala?.gala_no == selectedGala && galalist.building.building_no == selectedBuildingId)
      if (galaselected.length == 0) {
        toast.warn('Data Not Found !', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
    }
  }, [selectedBuildingId, selectedGala, selectedsGala, selname, userProject])



  if (soldGalaList) {
    var newData = Array.from(new Set(soldGalaList.map((item) => item.ownership).sort((a, b) => a - b)))
  }

  const debounce = useCallback(
    _.debounce((query) => {
      dispatch(loaderAction(true))
      let arr = []
      soldGalaList.map(
        item => {
          if ((item.Investors.name.toUpperCase()).includes(query.toUpperCase())) {
            arr.push(item)
          }
        }
      )
      if (arr.length != 0) {
        setGalaFilters(arr)
      } else {
        setGalaFilters([])
      }
    }, 600),
    []
  );

  const Clear = () => {
    setStopExtraClearCall(true)
    reset({
      "search": '',
      "building": "",
      "gala_no": "",
      "sub_gala_no": "",
      "proposal_status" : "",
    })
    if (selectedBuildingId.length != 0 || selectedGala.length != 0 || selectedsGala != 0) {
      toast.success('Filter Clear Successfully !', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    }
    setGalaFil([])
    SoldGalaFilterApiCall(true)
  }

  const handelBuildingChange = (event) => {
    setValue("building", event.target.value)
    setValue("gala_no", "")
    setValue("sub_gala_no", "")
  }

  const handelGalaChange = (event) => {
    setValue("gala_no", event.target.value)
    setValue("sub_gala_no", "")
  }

  const OnGalaSoldHandeler = async () => {
    getSoldGalaData();
    if(userProject){
      SoldGalaFilterApiCall();
    }
  }

  const SGFilterCallPageChange = async(localPage, localRecord) => {
    let SearchUrl = "";
    if(localPage != undefined){
      SearchUrl = `${environment.baseUrl}get-sold-galas-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}&subgala=${selectedsGala == undefined ? "" : selectedsGala}&owner=${ownership == undefined ? "" : ownership}&p=${localPage}&records=${records}`;
    }else if (localRecord != undefined){
      SearchUrl = `${environment.baseUrl}get-sold-galas-filter/?gala=${selectedGala == undefined ? "" : selectedGala}&building=${selectedBuildingId == undefined ? "" : selectedBuildingId}&project=${projectName[0]?.name}&investor=${selname == undefined ? "" : selname}&subgala=${selectedsGala == undefined ? "" : selectedsGala}&owner=${ownership == undefined ? "" : ownership}&p=1&records=${localRecord}`;
    }
    setLoading(true);
    const result = await axios(SearchUrl).then((res) => {
      if(res?.data?.next != null && nextIsValid != true){
        setNextIsValid(true)
      }else if(res?.data?.next == null && nextIsValid != false){
        setNextIsValid(false)
      }
      if(res?.data?.previous != null && prevIsValid != true){
        setPrevIsValid(true)
      }else if(res?.data?.previous == null && prevIsValid != false){
        setPrevIsValid(false)
      }
      if (res?.data?.results.length > 0) {
        const dat = res?.data?.results
        if (dat.length != 0) {
          setEmptyerr(false)
          setGalaFilters(dat);
          let area = 0;
          dat.map((data, i) => { area = Number(Number(data.sold_gala_area) - Number(data.resell_area)) + Number(area) })
          setArea(area)
        } else {
          setEmptyerr(true);
          setArea(0)
          dispatch(loaderAction(false))
        }
      } else {
        setEmptyerr(true);
        setArea(0)
      }
      setLoading(false);
    })
  }

  const pageChangeHandler = (LocalPageNo) => {
    if(((pageNo < LocalPageNo) && nextIsValid) || ((pageNo > LocalPageNo) && prevIsValid)){
      SGFilterCallPageChange(LocalPageNo, undefined) // page change call
      setPageNo(LocalPageNo)
    }
  }

  const recordChangeHandler = (recordSize) => {
    SGFilterCallPageChange(undefined, recordSize) // record change call
    setRecords(recordSize);
    setPageNo(1);
  }

  return (
    <>
      <PathName />
      <WarningPopup deleteData={deleteData} />
      <SoldGalaGroupModal toggle={tog} groupId={groupID} tog={setTog} />
      <ToastContainer />
      <Form >
        <div className='my-4 row'>
          <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <input
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                type='search'
                autoComplete='off'
                placeholder='Search Party Name...'
                {...register('search')}
              />
            </div>
          </div>
          {/* <div className='col-11 mx-auto mx-md-0 col-md-3 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("project", { required: true, onChange: (e) => { reset({ "building": "", "gala_no": "", "project": e.target.value }) } })}
              >
                <option value="">Project Name</option>
                {projectList?.map((data, i) => {
                  return <option value={data.name} key={i}>{data.name}</option>;
                })}
              </select>
            </div>
          </div> */}
          <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-2 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("building", { required: true, onChange: (e) => { handelBuildingChange(e) } })}
              >
                <option value="">Building Number</option>
                {filterBuilding?.sort((a, b) => a?.building_no?.localeCompare(b.building_no))?.map((data, i) => {
                  return (
                    <option value={data.building_no} key={i}>{data.building_no}</option>
                  );
                })}
              </select>
            </div>
            {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
            <br />
            {selectedBuildingId &&
              <>
                <Label className="fs-5 title-font-700 pt-1 mb-0 text-base-black">
                  Total Area : {Number(buildingfilterdata?.area_builtup).toFixed(2)} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sold Area : {Number(buildingfilterdata?.sold_area).toFixed(2)}<br />Remaining Area : {Number(buildingfilterdata?.area_builtup - buildingfilterdata?.sold_area).toFixed(2)}
                </Label>
              </>}
          </div>
          <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-3 col-xl-3 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("gala_no", { required: true, onChange: (e) => { handelGalaChange(e) } })}
              >
                <option value="">Gala No</option>
                {GalaFil?.sort((a, b) => (a?.gala_no || 0) - (b?.gala_no || 0))?.map((data, i) => {
                  return (
                    <option value={data?.gala_no} key={i}>{data?.gala_no}</option>
                  );
                })}
              </select>
            </div>
            {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
            {selectedGala &&
              <>
                <Label className="fs-5 title-font-700 pt-1 mb-0 text-base-black">
                  Total Area : {Number(galafilterdata?.builtup_area)?.toFixed(2)} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sold Area : {Number(area)?.toFixed(2)}<br />Remaining Area : {Number(Number(galafilterdata?.builtup_area) - Number(area))?.toFixed(2)}
                </Label>
              </>}
            <br />
          </div>
          <div className='col-11 mx-auto mx-md-0 col-md-2 col-lg-2 col-xl-2 pb-3 pt-1'>
            <div className="mt-1  d-flex gap-3">
              <select
                id="role_type"
                name="role_type"
                className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                {...register("sub_gala_no", { required: true })}
              >
                <option value="">Sub Gala Name</option>
                {subGalaFilter?.sort((a, b) => a.localeCompare(b))?.map((data, i) => {
                  return (
                    <option value={data} key={i}>{data}</option>
                  );
                })}
              </select>
            </div>
            {/* {errors.village_name && <ErrorComponents error={'Village name is required *'} />} */}
            <br />
          </div>
          <div className='col-11 mx-auto mx-md-0 col-md-1 col-lg-1 col-xl-1 pb-3 pt-1'>
            <button onClick={Clear} type="button" className="border-radius-7  d-flex align-items-center buttons  py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
          </div>
        </div>
      </Form>
      <SuccessPopups />
      <div className="bg-white p-4 p-md-4 p-lg-5 p-xl-5 d-flex gap-5 flex-column rounded-5 mt-1 mb-5">
        <div className="">
          <div className="d-flex justify-content-between align-items-start align-items-md-center align-content-lg-center align-items-xl-center  flex-column flex-md-row flex-lg-row flex-xl-row">
            <div className='pb-md-5 pb-lg-5 pb-xl-5'>
              <h1 className='title-font-bold '>Sale Galas</h1>
            </div>
            <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
              <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                {soldGalas!= undefined ?(<select
                  id="ProposalStatus"
                  name="Proposal_Status"
                  className="p-3 select-width   border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input "
                  {...register("proposal_status",)}
                >
                  <option value="">Select Status</option>
                  {newData?.map((data, i) => {
                    return <option value={data} key={i}>{data} Owner</option>;
                  })}
                </select>):
                  (<select
                    id="ProposalStatus"
                    name="Proposal_Status"
                    className="p-3 select-width   border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input "
                    {...register("proposal_status",)}
                  >
                    <option value="">Select Status</option>
                    <option value="1">1st Owner</option>
                    <option value="2">2nd Owner</option>
                    <option value="3">3rd Owner</option>
                    <option value="4">4th Owner</option>
                    <option value="5">5th Owner</option>
                    <option value="6">6th Owner</option>
                  </select>)
                }
              </div>
              <div className='d-flex mr-2 gap-3'>
                <Excel investor={true} data={GalaFilters?.length > 0 ? GalaFilters : soldGalaList} soldgala={true} />
                <SoldGalasModal galaSoldHandeler={OnGalaSoldHandeler} />
                <ResellGalasModal className='ms-2' galaSoldHandeler={OnGalaSoldHandeler} /></div>
            </div>
          </div>
          {loading && <div className="bg-white p-5 rounded-5 mb-5"><LoadBox /></div>}
          {!loading && (GalaFilters?.[0] == undefined? <EmptyTable /> : emptyerr == true ? <EmptyTable /> : <><Table pageinationProp={true} columns={columns} data={GalaFilters} soldGala={true} groupid={setGroupID} tog={setTog} />
            <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
              <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                {""}
              </div>
              <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
                <select
                    className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                    defaultValue={"10"}
                    {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
                  >
                    <option value="8">8</option>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                  
                </select>
                <span onClick={() => {pageChangeHandler(pageNo-1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold"/></span>
                <span onClick={() => {pageChangeHandler(pageNo+1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold"/></span>
              </div>
            </div>
          </>)}
        </div>
      </div>

    </>
  )
}

export default SoldGalas